module.exports = __webpack_public_path__ + "img/algorand.aaea4c66.png";